import { CalendarComponentOptions } from 'ion2-calendar';
import { Ortak } from './../../providers/ortak';
import { BllOrtak } from './../../providers/bll/bll-ortak';
import { Component, ViewChild } from '@angular/core';
import {  NavController, NavParams } from 'ionic-angular';
import { ViewController } from 'ionic-angular/navigation/view-controller';

/**
 * Generated class for the GunlukGelenUrunlerPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

 
@Component({
  selector: 'page-gunluk-gelen-urunler',
  templateUrl: 'gunluk-gelen-urunler.html',
})
export class GunlukGelenUrunlerPage {
  @ViewChild('sideNavUrunAra') sideNav;
  GelenListe = [];
 
  aranan = "";
  toplamalacak: number = 0;
  toplamPalsan: number = 0;
  toplamKasa: number = 0;
  take: number = 5000;
  tarih1: any;
  tarih2: any;
  cihazid = "";
  musteriListesi = [];
  secilengrup: number = 1;
  ServerParamet: any = { FirmaAdi: "", FirmaTelefonu: "", FirmaAdres: "", FirmaEmail: "", FirmaWeb: "", FirmaVD: "", FirmaVN: "" };
  dateRange: {
    from: Date
    to: Date
  } = {
      from: this.tarih1,
      to: this.tarih2
    };
  type: 'string'; // 'string' | 'js-date' | 'moment' | 'time' | 'object'
  optionsRange: CalendarComponentOptions = {
    from: new Date(2016, 1, 1),
    pickMode: 'range',
    color: "primary",
    monthPickerFormat: ["Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran", "Tem", "Agust", "Eylül", "Ekim", "Kasım", "Aralık"]
  };

  
  constructor(public navCtrl: NavController,
    public bllOrtak: BllOrtak,
    public ortak: Ortak,
  
    public viewCtrl: ViewController,
    public navParams: NavParams) {
     
 
    this.tarih1 = this.ortak.tarih(this.ortak.storageGunTarihiGetir);
    this.tarih2 = this.tarih1;
  }

  ionViewDidLoad() {
    this.dateRange.from = this.ortak.storageGunTarihiGetir;
    this.dateRange.to = this.ortak.storageGunTarihiGetir;
    this.closeNav();
    this.gunsonurapor('');
  }
  openNav() {
    let sideElement = this.sideNav.nativeElement
    sideElement.style.display = "block";
  }
  closeNav() {
    let sideElement = this.sideNav.nativeElement;
    sideElement.style.display = "none";
  }
  gunsonurapor(e) {
    var formData = new FormData();
    formData.append("tarih1", this.ortak.tarih(this.dateRange.from));
    formData.append("tarih2", this.ortak.tarih(this.dateRange.to));
    formData.append("carikodu", this.aranan);
 
    this.bllOrtak.islem(formData, "GunlukGelenUrunler", "", false).then(a => {
      var sonuc = <any>a;
      this.GelenListe = sonuc.SonucObject;
      this.toplamPalsan=0;
      this.toplamKasa=0;
this.GelenListe.forEach( element=>{
  if(element.StokAdi.includes("Palsan"))
  {
    this.toplamPalsan+=element.Miktar;
  }
  else{
    this.toplamKasa+=element.Miktar;
  }
}

)

    //   this.AlacakliListesi.forEach(element => {
    //     element.Bakiyesi = element.Bakiyesi * -1;
    //     this.toplamalacak += element.Bakiyesi;
    //   });
    //   console.log("ls",this.AlacakliListesi);
    //   this.AlacakliListesi2 = this.AlacakliListesi.filter(a => a.Bakiyesi != 0);
    // })
  })
}
 
 
 
  // pdf() {
  //   var html = "<html><head>  <link href='https://stackpath.bootstrapcdn.com/bootstrap/4.1.1/css/bootstrap.min.css' rel='stylesheet'></head><body>" +
  //     "<table style='width: 100%;border-bottom:1px solid lightgray;margin-bottom:30px'>" +
  //     "<tbody>" +
  //     "<tr>" +
  //     "<td style'width: 41.8357%;'>&nbsp;</td>" +
  //     "<td style='width: 53.1643%;'><span style='float:left;width:100%;text-align:right'> {{ServerParamet.FirmaAdres}}</span></td>" +
  //     "</tr>" +
  //     "<tr>" +
  //     "<td style='width: 41.8357%;'>&nbsp;<span style='color: #cc0000;'><strong style='font-size: 30px;'><strong>{{ServerParamet.FirmaAdi}}</strong></strong></span></td>" +
  //     "<td style='width: 53.1643%;'><span style='float:left;width:100%;text-align:right'> {{ServerParamet.FirmaTelefonu}}</span></td>" +
  //     "</tr>" +
  //     "<tr>" +
  //     "<td style='width: 41.8357%;'>&nbsp;</td>" +
  //     "<td style='width: 53.1643%;'><span style='float:left;width:100%;text-align:right'> {{ServeParamet.FirmaWeb}}</span></td>" +
  //     "</tr>" +
  //     "</tbody>" +
  //     "</table>" +
  //     "<div class='card text-center'>" +
  //     "<div class='card-footer text-muted'>" +
  //     "Alacaklı Hesaplar Listesi" +
  //     "</div>" +
  //     "</div><hr/>" +
  //     "<table class='table table-striped table-bordered table-hover'>" +
  //     "<thead>" +
  //     "<tr>" +
  //     "<th>Cari Hesap Adı</th>" +
  //     "<th>Açıklama</th>" +
  //     "<th>Tarih</th>" +
  //     "<th>Miktar</th>" +
  //     "</tr>" +
  //     "</thead>" +
  //     "<tbody>";
  //   this.AlacakliListesi2.forEach(extre => {
  //     html = html + "<tr>";
  //     html = html + "<td>" + extre.Definition_ + "</td>";
  //     html = html + "<td>" + extre.Aciklama + "</td>";
  //     html = html + "<td>" + extre.Tarih + "</td>";
  //     html = html + "<td>" + extre.Miktar.toFixed(2) + "</td>";
  //     html = html + "</tr>";
  //   });
  //   html = html + "<table style='width:100%'>";
  //   html = html + "<tr>";
  //   html = html + "<td>";
  //   html = html + "<span style='float:left;width:100%;text-align:right'>Toplam Miktar: " + this.Miktar.toFixed(2) + " </span>";
  //   html = html + "</td>";
  //   html = html + "</tr>";
  //   html = html + "</table>";
  //   html = html + "</body></html>";
  //   html = html + "</tbody></table></body></html>";
  //   cordova.plugins.pdf.htmlToPDF({
  //     data: html,
  //     documentSize: "A4",
  //     landscape: "portrait",
  //     type: "share"
  //   },
  //     (sucess) => console.log('sucess: ', sucess),
  //     (error) => console.log('error:', error));
  // }
  excel() {
    var data = [];
    this.GelenListe.forEach(element => {
      data.push({
        "Adı": element.Definition_,
        "StokAdi": element.StokAdi,
        "Açıklama": element.Aciklama,
        "Miktar": element.Miktar,
        "Tarih": element.StokHareketIslemTarihi
      })
    });
    this.ortak.ExportExcel(data, "Hareketler-" + this.tarih1).then(a => {
    }).catch(x => {
    });
  }
  kapat() {
    this.viewCtrl.dismiss();
  }
 }



// WEBPACK FOOTER //
// ./src/pages/gunluk-gelen-urunler/gunluk-gelen-urunler.ts